import { render } from "./BaseYearPicker.vue?vue&type=template&id=3cebe8e2"
import script from "./BaseYearPicker.vue?vue&type=script&lang=js"
export * from "./BaseYearPicker.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__